import React, { useEffect } from 'react';
import cn from 'classnames';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import SiteHeader from '@wix/da-shared-react/pkg/SiteHeader';
import SiteFooter from '@wix/da-shared-react/pkg/SiteFooter';
import DrawerLoadable from '@wix/da-feedback-shared/pkg/Drawer/DrawerLoadable';
import FeedbackPageLoadable from '@wix/da-feedback-shared/pkg/FeedbackPage/FeedbackPageLoadable';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import {
  ThemeOverride,
  ThemeOptions,
  ThemeSkin,
} from '@wix/da-react-context/pkg/ThemeContext';
import { submitModalRenderer } from '@wix/da-submit-shared/pkg/project-tools';
import Picker from '../Pages/Picker';
import { type PackagePickerStoreSlice } from '../../../redux/packagePicker/types';

import s from './App.scss';

export interface Props {
  language: string;
  environment?: RuntimeEnvironment;
  pickerStep?: PackagePickerStoreSlice['pickerStep'];
  appMounted: (pageName: string) => void;
}

const App: React.FC<Props> = ({
  language,
  environment,
  pickerStep,
  appMounted,
}) => {
  useEffect(() => {
    appMounted('package-picker');
  }, [appMounted]);

  const MainComponent = Picker;

  return (
    <DaApp
      language={language}
      environment={environment}
      bodyClassName={cn(s['body'], 'no-theme-skin')}
      theme={ThemeOptions.DARK}
      themeSkin={ThemeSkin.NONE}
      ncContextProps={{
        PageComponent: FeedbackPageLoadable,
        DrawerComponent: DrawerLoadable,
      }}
      modalsRenderFunc={submitModalRenderer}
    >
      <ThemeOverride theme={ThemeOptions.DARK} themeSkin={ThemeSkin.NONE}>
        <SiteHeader disableFixed minimalMode />
        <MainComponent />
        <SiteFooter />
      </ThemeOverride>
    </DaApp>
  );
};
App.displayName = 'PackagePickerApp';

export default App;
